/**
 * Popup System Initialization and Coordination
 * Responsible for initializing and coordinating various modules
 */
(function () {
  // Private helper functions
  const _loadConfiguration = () => {
    try {
      const configElement = document.getElementById("popup-configuration-data");
      if (configElement) {
        const config = JSON.parse(configElement.textContent);
        return config;
      }
      return null;
    } catch (e) {
      return null;
    }
  };

  const init = () => {
    console.log("[en-route-jewelry] Initializing popup system...");

    // TODO - is it necessary to check each module initialization success?

    // Load popup configuration data
    const sysConfig = _loadConfiguration();

    if (!sysConfig?.enabled || !sysConfig?.popups?.length) return;

    // Initialize queue management
    window._erj_.PopupQueue.init();
    // Initialize auto-triggers (if configuration loaded successfully and enabled)
    window._erj_.PopupTriggers.init(sysConfig?.popups);

    // TODO - common logic initialization here

    console.log("[en-route-jewelry] Popup system initialization completed");
  };

  // Initialize after document is loaded
  document.addEventListener("DOMContentLoaded", async function () {

    // const isLotteryWheelEnabled = await window._erj_?.getFeatureValue?.("lottery-wheel") || false;

    if(!noPopupMode){
      init();
    }
    
    
  });
})();
